import { FC, useEffect, useState } from 'react'
import { Outlet } from 'react-router-dom'
import { logout } from '../api/axiosAuthorization'
import ResponsiveLayout from '../components/layout/ResponsiveLayout'
import Footer from '../components/layouts/Footer'
import Header from '../components/layouts/Header'
import SideBar from '../components/layouts/SideBar'
import {
  reloadBatches,
  reloadGroups,
  reloadGroupsWithSchoolsAndTanks,
} from '../utils/loadStorage'
import { useMediaQuery } from '../utils/responsiveUtils'

const Layout: FC = () => {
  const isMobile = useMediaQuery('(max-width: 767px)')
  const isTablet = useMediaQuery('(min-width: 768px) and (max-width: 1023px)')
  const [useResponsiveLayout, setUseResponsiveLayout] = useState(true)

  // Load initial data for Home page
  useEffect(() => {
    reloadBatches()                       // Batch info (still used in some places)
    reloadGroups()                        // Group list (id, name only)
    reloadGroupsWithSchoolsAndTanks()     // Group + School + Tank details (includes empty/released tanks)
  }, [])


  // Use responsive layout for mobile and tablet
  if (useResponsiveLayout && (isMobile || isTablet)) {
    return <ResponsiveLayout showSidebar={true} sidebarContent={<SideBar />} onLogout={logout} />
  }

  // Desktop layout with responsive improvements
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <div className="flex flex-1 relative">
        <aside className="hidden lg:block w-48 xl:w-52 flex-shrink-0">
          <SideBar />
        </aside>
        <main className="flex-1 bg-tdplbisque bg-repeat-y overflow-x-hidden border-l border-tdpldarkgrey border-opacity-50 p-10">
          <div className="w-full">
            <Outlet />
          </div>
        </main>
      </div>
      <Footer />
    </div>
  )
}

export default Layout
